
import styles from "../../FieldTypeModal.module.scss";



type Props = {
    onChange: (val: boolean) => void
    value: boolean
    fieldLabel: string
    option1 : string
    option2 : string
}


export const ChoseBoolFiledConfig = (props: Props) => {

    return <div className={styles.configurationField}>
        <div className={styles.title}>
            <span className={styles.label}>{props.fieldLabel}</span>
        </div>
        <div className={styles.body}>
            <div className={styles.yesNOdiv}>
                <div onClick={() => props.onChange(true)} className={props.value ? styles.active : ""}>
                    {props.option1}
                </div>
                <div onClick={() => props.onChange(false)} className={props.value ?  "" : styles.active}>
                    {props.option2}
                </div>
            </div>
        </div>
    </div>
}